
/* injects from baggage-loader */

'use strict';

import BallonsTpl from './balloons.html';
import BallonsController from './balloons.controller';
import './balloons.scss';

export default function directive($log){
	'ngInject';

	return {
		restrict: "E",
		templateUrl: BallonsTpl,
		controller: BallonsController,
		transclude: true,
		scope: {
			data: "=",
			onFinish: "="
		},
		link: function (scope, element, attrs, ctrl, transcludeFn) {
			$log.debug(scope);
			scope.$balloons = angular.merge(ctrl, { data: scope.data, onFinish: scope.onFinish });
			transcludeFn(scope, clone => {
				element.find('ballons-transclude').html(clone);
			});
		}
	};
}


// WEBPACK FOOTER //
// ./src/app/components/balloons/balloons.directive.js